import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {NgModule, SystemJsNgModuleLoader} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ChartsModule} from 'ng2-charts';
import {AngularMaterialModules} from './shared/shared.module';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {ErrorModule} from './error/error.module';
import {SharedModule} from './shared/shared.module';

import {Principal} from './shared/auth/principal.service';
import {AccountService} from './shared/auth/account.service';
import {LoginService} from './login.service';
import {AuthServerProvider} from './shared/auth/auth-jwt.service';
import {StateStorageService} from './shared/auth/state-storage.service';
import {DataStorageService} from './shared/data-storage.service';
import {UserRouteAccessService} from './shared/auth/user-route-access-service';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {AuthInterceptor} from './blocks/interceptor';
import {LoaderComponent} from './shared/loader/loader.component';
import {LoaderService} from './shared/loader/loader.service';
import {LoginComponent} from './login/login.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {InputTrimModule} from 'ng2-trim-directive';
import {InterceptorUtil} from './blocks/interceptor/InterceptorUtil';
import {RefundReqResDialog} from './report/pg-detailed-transaction-report/refund-req-res-dialog.component';
import {DisputeListDialog} from './report/dispute-list/dispute-list-dialog.component';
import {RefundRequestStatusDialog} from './report/refund-request/refund-request.component';
import {CommonDirectiveModule} from './shared/common-directive/common-directive.module';
import {RefundDialogComponent} from './report/refund-list/refund.dialog.component';
import {ChangeStatusDialogComponent} from './report/admin-report/dialog/change-status-dialog/change-status-dialog.component';
import {BKashWalletBalanceDialog} from './report/disburse-list/dialog/bkash.wallet.balance.dialog.component';
import {ConfigurationService} from './common/configuration.service';
import {DashboardsModule} from "./dashboards/dashboards.module";
import { EmiChangeStatusDialogComponent } from './report/pg-emi-detailed-transaction-report/dialog/emi-change-status-dialog/emi-change-status-dialog.component';
import {NgSelectModule} from '@ng-select/ng-select';
import { ChangeTransactionStatusDialogComponent } from './report/pg-detailed-transaction-report/change-transaction-status-dialog/change-transaction-status-dialog.component';
import { SentryErrorHandler } from './SentryErrorHandler';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'i18n/root/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoaderComponent,
    RefundDialogComponent,
    ChangeStatusDialogComponent,
    EmiChangeStatusDialogComponent,
    ChangeTransactionStatusDialogComponent,
    RefundReqResDialog, DisputeListDialog, BKashWalletBalanceDialog, RefundRequestStatusDialog
  ],
  entryComponents: [
    RefundDialogComponent,
    ChangeStatusDialogComponent,
    EmiChangeStatusDialogComponent,
    ChangeTransactionStatusDialogComponent,
    RefundReqResDialog, DisputeListDialog, BKashWalletBalanceDialog, RefundRequestStatusDialog
  ],
  imports: [
    DashboardsModule,
    BrowserModule,
    CommonModule,
    HttpClientModule,
    InputTrimModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ChartsModule,
    SharedModule,
    ErrorModule,
    AngularMaterialModules,
    LoggerModule.forRoot({level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    }),
    CommonDirectiveModule,
    NgSelectModule
  ],
  exports: [SharedModule],
  providers: [
    LoaderService,
    ConfigurationService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    LoginService,
    Principal,
    AccountService,
    AuthServerProvider,
    LocalStorageService,
    SessionStorageService,
    StateStorageService,
    DataStorageService,
    InterceptorUtil,
    UserRouteAccessService,
    SystemJsNgModuleLoader,
    SentryErrorHandler
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts